import { connect } from 'react-redux';
import ProfileManager from './ProfileManager';

const mapStateToProps = (state) => ({
  userManager: state.userManager,
});

export default connect(mapStateToProps, null)(ProfileManager);
